<template>
  <section class="navigation-overlay" @click="$global.workItem = null">
    <article class="navigation-overlay__container" @click.stop>
      <button class="navigation-overlay__close" @click="$global.workItem = null">
        <svg-icon id="close" />
      </button>

      <section class="navigation-overlay__section -header">
        <div class="navigation-overlay__content">
          <h2 v-scroll:reveal="{ delay: 125 }" class="layout-section__title">{{ item.title }}</h2>
          <div v-scroll:reveal="{ delay: 200 }" v-html="item.description" />
        </div>

        <figure v-scroll:reveal="{ delay: 75 }" class="layout-section__figure -alt" :style="imageStyle" />
      </section>

      <section class="navigation-overlay__section layout-grid -half">
        <figure v-for="image in gallery" :key="image" class="layout-grid__item -image-solo" :style="{ backgroundImage: `url('${image}')` }"/>
      </section>

      <section class="navigation-overlay__section -spacing">
        <div class="navigation-overlay__cta">
          <h2 class="layout-section__title">{{ $t('projectCta.title') }}</h2>
          <div v-html="$t('projectCta.text')" />
          <a :href="item.link || 'https://mariedooley.com/collections/artwork/products'" target="_blank" class="button layout-section__cta">{{ $t('projectCta.label') }}</a>
        </div>

        <div class="navigation-overlay__end">
          <button @click="$global.workItem = null">{{ $t('backToProjects') }}</button>
        </div>
      </section>
    </article>
  </section>
</template>

<script>
export default {
  name: 'WorkItemOverlay',
  computed: {
    item() {
      return this.$global.workItem
    },
    imageStyle() {
      return { backgroundImage: `url('${this.item.images[0]}')` }
    },
    gallery() {
      return this.item.images.slice(1)
    }
  },
  // created() {
  //   this.$scroll.prevent()
  // },
  // beforeDestroy() {
  //   this.$scroll.restore()
  // }
}
</script>
